<template>
  <hm-content title="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
    >
      <el-form-item label="标签名称" prop="labelName">
        <el-input
          :disabled="disabled"
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.labelName"
          placeholder="请输入标签名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="标签组" prop="groupId">
        <el-select v-model="ruleForm.groupIds" multiple filterable size="small" :disabled="disabled" clearable placeholder="请选择标签">
          <el-option
              v-for="item in labelGroupList"
              :key="item.groupId"
              :label="item.groupName"
              :value="item.groupId">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="标签类型" prop="labelType">
        <el-radio v-model="ruleForm.labelType" label="manual" disabled
          >手动标签</el-radio
        >
        <el-radio v-model="ruleForm.labelType" label="auto" disabled
          >自动标签</el-radio
        >
        <el-form-item
          label="满足条件"
          prop="seqNum"
          v-if="ruleForm.labelType === 'auto'"
        >
          <el-radio
            disabled
            v-model="ruleForm.selectConditionType"
            label="anyone"
            >满足任意一个被选中条件即可</el-radio
          >
          <el-radio disabled v-model="ruleForm.selectConditionType" label="all"
            >必须满足所有被选择条件</el-radio
          >
        </el-form-item>
      </el-form-item>
      <el-form-item
        label="数据来源"
        prop="dataSources"
        v-if="ruleForm.labelType === 'auto'"
      >
        <el-radio-group v-model="ruleForm.dataSources" size="small" disabled>
          <el-radio label="online">线上订单</el-radio>
          <el-radio label="offline">线下订单</el-radio>
        </el-radio-group>
      </el-form-item>

      <div v-if="ruleForm.labelType === 'auto'">
        <el-form-item label="商品预购" prop="transaction">
          <template>
            <!-- `checked` 为 true 或 false -->
            <div>
              交易时间范围
              <el-form-item>
                <div>
                  <el-radio
                    v-model="ruleForm.transaction_time.isSelected"
                    label="1"
                    >最近<el-input
                      :disabled="disabled || transaction"
                      size="small"
                      clearable
                      @input="
                        filterGt0OrFixed0('transaction_time', 'latelyValue')
                      "
                      class="mr10 ipt"
                      v-model.trim="ruleForm.transaction_time.latelyValue"
                      placeholder="请填写365天内"
                    ></el-input
                    >天</el-radio
                  >
                </div>
                <div>
                  <el-radio
                    v-model="ruleForm.transaction_time.isSelected"
                    label="2"
                  >
                    自定义
                    <el-date-picker
                      :disabled="disabled || !transaction"
                      :default-time="['00:00:00', '23:59:59']"
                      :picker-options="pickerOptions"
                      v-model="ruleForm.transaction_time.activityDate"
                      type="datetimerange"
                      align="right"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      size="small"
                      class="mr10"
                    ></el-date-picker>
                  </el-radio>
                </div>
              </el-form-item>
            </div>
          </template>
        </el-form-item>
        <!-- <el-form-item prop="consumption">
          <div>
            <el-checkbox v-model="ruleForm.lately_consumption_time.enabledState"
              >最后消费时间</el-checkbox
            >
            <el-form-item>
              <div>
                <el-radio
                  v-model="ruleForm.lately_consumption_time.isSelected"
                  label="1"
                  >最近<el-input
                    :disabled="disabled || consumption"
                    type="number"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.lately_consumption_time.latelyValue"
                    placeholder="请填写90天内"
                  ></el-input
                  >天</el-radio
                >
              </div>
              <div>
                <el-radio
                  v-model="ruleForm.lately_consumption_time.isSelected"
                  label="2"
                >
                  自定义
                  <el-date-picker
                    :disabled="disabled || !consumption"
                    :default-time="['00:00:00', '23:59:59']"
                    :picker-options="pickerOption"
                    v-model="ruleForm.lately_consumption_time.activityDate"
                    type="datetimerange"
                    align="right"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                    class="mr10"
                  ></el-date-picker>
                </el-radio>
              </div>
            </el-form-item>
          </div>
        </el-form-item> -->
        <el-form-item prop="cumulative">
          <div>
            <el-checkbox
              v-model="ruleForm.cumulative_consumption_times.enabledState"
            >
              累计消费次数
              <el-input
                :disabled="disabled"
                @input="
                  filterGt0OrFixed0(
                    'cumulative_consumption_times',
                    'lowerValue'
                  )
                "
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.cumulative_consumption_times.lowerValue"
                placeholder="最小值"
              ></el-input>
              -
              <el-input
                @input="
                  filterGt0OrFixed0(
                    'cumulative_consumption_times',
                    'upperValue'
                  )
                "
                :disabled="disabled"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.cumulative_consumption_times.upperValue"
                placeholder="最大值"
              ></el-input
              >次
            </el-checkbox>
          </div>
        </el-form-item>
        <el-form-item prop="amount">
          <div>
            <el-checkbox
              v-model="ruleForm.cumulative_consumption_amount.enabledState"
            >
              累计消费金额
              <el-input
                :disabled="disabled"
                size="small"
                clearable
                class="mr10 ipt"
                @input="
                  filterGt0OrFixed2(
                    'cumulative_consumption_amount',
                    'lowerValue'
                  )
                "
                v-model.trim="ruleForm.cumulative_consumption_amount.lowerValue"
                placeholder="最小值"
              ></el-input>
              -
              <el-input
                :disabled="disabled"
                @input="
                  filterGt0OrFixed2(
                    'cumulative_consumption_amount',
                    'upperValue'
                  )
                "
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.cumulative_consumption_amount.upperValue"
                placeholder="最大值"
              ></el-input
              >元
            </el-checkbox>
          </div>
        </el-form-item>
        <el-form-item prop="unitPrice">
          <div>
            <el-checkbox v-model="ruleForm.customer_unit_price.enabledState">
              客单价
              <el-input
                @input="filterGt0OrFixed2('customer_unit_price', 'lowerValue')"
                :disabled="disabled"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.customer_unit_price.lowerValue"
                placeholder="最小值"
              ></el-input>
              -
              <el-input
                @input="filterGt0OrFixed2('customer_unit_price', 'upperValue')"
                :disabled="disabled"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.customer_unit_price.upperValue"
                placeholder="最大值"
              ></el-input
              >元
            </el-checkbox>
          </div>
        </el-form-item>
        <!-- <el-form-item label="资产条件" prop="integral">
          <el-checkbox
            v-model="ruleForm.cumulative_total_integral.enabledState"
          >
            累计获得积分
            <el-input
              type="number"
              :disabled="disabled"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.cumulative_total_integral.lowerValue"
              placeholder="0"
            ></el-input>
            -
            <el-input
              type="number"
              :disabled="disabled"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.cumulative_total_integral.upperValue"
              placeholder="0"
            ></el-input
            >分
          </el-checkbox>
        </el-form-item> -->
        <el-form-item label="商品条件" prop="goodsConditionsBo">
          <el-checkbox v-model="ruleForm.goodsConditionsBo.enabledState">
            购买以下任意商品（商品黑白名单）
          </el-checkbox>
          <el-button type="primary" @click="dialogVisible = true" size="small"
            >添加商品</el-button
          >
          <div class="tabless">
            <div class="table-out-header flex flex-center">
              <!-- <div> -->
              <!-- <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange"
                  >全选</el-checkbox
                > -->
              <!-- </div> -->
              <div>
                已选商品
              </div>
              <!-- <div @click="deleteSelected" class="delete">
                <span class="delete-icon hmicon icon-shanchu"></span>
                删除
              </div> -->
            </div>
            <div class="table-header flex flex-between">
              <div class="flex-1 num">商品货号</div>
              <div class="flex-2 text-center">商品名</div>
              <div class="flex-1 text-center">状态</div>
              <div class="flex-1 text-center">操作</div>
            </div>
            <div class="table-body">
              <el-scrollbar
                ref="scrollContainer"
                :vertical="false"
                wrap-style="max-height: 500px;"
              >
                <el-checkbox-group
                  v-model="checkedGoods"
                  @change="handleCheckedGoodsChange"
                >
                  <div class="list-item" v-for="(v, i) in result" :key="i">
                    <div class="row flex flex-between">
                      <div class="flex-3 flex">
                        <div class="flex flex-1">
                          <el-tooltip :content="v.attrId" placement="top" >
                          <div class="flex flex-1 attrid">{{ v.attrId }}</div>
                          </el-tooltip>
                          <el-tooltip :content="v.attrValue" placement="top" >
                          <div class="flex flex-2 attrid flex-center">
                            {{ v.attrValue }}
                          </div>
                          </el-tooltip>
                        </div>
                      </div>

                      <div class="flex-1 text-center">
                        <span
                          v-if="v.whitelistState === 'white'"
                          class="select-type white"
                          >白</span
                        >
                        <span
                          v-if="v.whitelistState === 'black'"
                          class="select-type black"
                          >黑</span
                        >
                      </div>
                      <div
                        class="flex-1 text-center"
                        @click="deleteCurrentGoods(v, i)"
                      >
                        <span
                          class="primary delete-icon hmicon icon-shanchu"
                        ></span>
                      </div>
                    </div>
                  </div>
                </el-checkbox-group>
              </el-scrollbar>
              <div class="no-message text-center" v-show="!result.length">
                请添加商品!
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="openCardDay">
          <div>
            <el-checkbox v-model="ruleForm.openCard_day.enabledState">
              开卡注册
              <el-input
                  @input="
                  filterGt0OrFixed0(
                    'openCard_day',
                    'openCardDay'
                  )
                "
                  :disabled="disabled"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.openCard_day.openCardDay"
                  placeholder="最小值"
              ></el-input>
              天内的会员
            </el-checkbox>
          </div>
        </el-form-item>
        <el-form-item prop="openCardNotConsumed">
          <div>
            <el-checkbox
                v-model="ruleForm.openCard_not_consumed.enabledState"
            >
              开卡注册
              <el-input
                  @input="
                  filterGt0OrFixed2(
                    'openCard_not_consumed',
                    'openCardDay'
                  )
                "
                  :disabled="disabled"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.openCard_not_consumed.openCardDay"
                  placeholder="最小值"
              ></el-input>
              天内未消费的会员
            </el-checkbox>
          </div>
        </el-form-item>
        <el-form-item prop="openCardConsumptionAmount">
          <div>
            <el-checkbox v-model="ruleForm.openCard_consumption_amount.enabledState">
              开卡注册
              <el-input
                  @input="filterGt0OrFixed2('openCard_consumption_amount', 'openCardDay')"
                  :disabled="disabled"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.openCard_consumption_amount.openCardDay"
                  placeholder="最小值"
              ></el-input>
              天内，累计消费金额
              <el-input
                  @input="filterGt0OrFixed2('openCard_consumption_amount', 'lowerValue')"
                  :disabled="disabled"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.openCard_consumption_amount.lowerValue"
                  placeholder="最小值"
              ></el-input
              >-
              <el-input
                  @input="filterGt0OrFixed2('openCard_consumption_amount', 'upperValue')"
                  :disabled="disabled"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.openCard_consumption_amount.upperValue"
                  placeholder="最大值"
              ></el-input
              >元的会员
            </el-checkbox>
          </div>
        </el-form-item>
        <el-form-item prop="openCardConsumptionTimes">
          <div>
            <el-checkbox v-model="ruleForm.openCard_consumption_times.enabledState">
              开卡注册
              <el-input
                  @input="filterGt0OrFixed2('openCard_consumption_times', 'openCardDay')"
                  :disabled="disabled"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.openCard_consumption_times.openCardDay"
                  placeholder="最小值"
              ></el-input>
              天内，累计消费次数
              <el-input
                  @input="filterGt0OrFixed2('openCard_consumption_times', 'lowerValue')"
                  :disabled="disabled"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.openCard_consumption_times.lowerValue"
                  placeholder="最小值"
              ></el-input
              >-
              <el-input
                  @input="filterGt0OrFixed2('openCard_consumption_times', 'upperValue')"
                  :disabled="disabled"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.openCard_consumption_times.upperValue"
                  placeholder="最大值"
              ></el-input
              >次的会员
            </el-checkbox>
          </div>
        </el-form-item>
      </div>
      <el-form-item label="启用状态">
        <el-switch
          v-model="ruleForm.enabledState"
          active-color="#2d8"
          inactive-color="#ddd"
          active-text="开启"
          inactive-text="关闭"
          active-value="yes"
          inactive-value="no"
        ></el-switch>
      </el-form-item>
      <div class="flex flex-center">
        <el-button
          type="primary"
          v-if="!disabled"
          size="small"
          @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>
    <el-dialog
      title="添加商品"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <hm-transfer
        queryIsUsed
        showUseable
        dialogVisible
        ref="ruleTransfer"
        showAttribute
        :leftOption="leftRules"
      ></hm-transfer>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="saveSelected" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmTransfer from "@/components/HmMicroShopTransfer";
export default {
  components: {
    HmTransfer
  },
  data() {
    const goodsConditionsBo = function(rule, val, callback) {
      if (this.result.length > 0) {
        this.ruleForm.goodsConditionsBo.enabledState = true;
      } else {
        this.ruleForm.goodsConditionsBo.enabledState = false;
      }
      callback();
    }.bind(this);

    const integral = function(rule, val, callback) {
      const lowerValue = +this.ruleForm.cumulative_total_integral.lowerValue;
      const upperValue = +this.ruleForm.cumulative_total_integral.upperValue;
      let reg = new RegExp("^[0-9]*$");
      if (this.ruleForm.cumulative_total_integral.enabledState) {
        if (lowerValue == "" || upperValue == "") {
          return callback(new Error("不能未空"));
        }
        if (!reg.test(lowerValue) || !reg.test(upperValue)) {
          return callback(new Error("请填写数字"));
        } else if (+lowerValue > +upperValue) {
          return callback(new Error("最小值不能大于最大值"));
        }
      } else {
        if (lowerValue || upperValue) {
          this.ruleForm.cumulative_total_integral.enabledState = true;
        }
      }
      callback();
    }.bind(this);

    const unitPrice = function(rule, val, callback) {
      const lowerValue = +this.ruleForm.customer_unit_price.lowerValue;
      const upperValue = +this.ruleForm.customer_unit_price.upperValue;

      if (this.ruleForm.customer_unit_price.enabledState) {
        if (lowerValue == "" || upperValue == "") {
          return callback(new Error("不能未空"));
        } else {
          if (lowerValue <= 0) {
            return callback(new Error("最小值需大于0"));
          } else {
            if (+lowerValue > +upperValue) {
              return callback(new Error("最小值不能大于最大值"));
            }
          }
        }
      } else {
        if (lowerValue || upperValue) {
          this.ruleForm.customer_unit_price.enabledState = true;
        }
      }
      callback();
    }.bind(this);

    const amount = function(rule, val, callback) {
      const lowerValue = +this.ruleForm.cumulative_consumption_amount
        .lowerValue;
      const upperValue = +this.ruleForm.cumulative_consumption_amount
        .upperValue;

      if (this.ruleForm.cumulative_consumption_amount.enabledState) {
        if (lowerValue == "" || upperValue == "") {
          return callback(new Error("不能未空"));
        }
        if (+lowerValue > +upperValue) {
          return callback(new Error("最小值不能大于最大值"));
        }
      } else {
        if (lowerValue || upperValue) {
          this.ruleForm.cumulative_consumption_amount.enabledState = true;
        }
      }
      callback();
    }.bind(this);
    const cumulative = function(rule, val, callback) {
      const lowerValue = +this.ruleForm.cumulative_consumption_times.lowerValue;
      const upperValue = +this.ruleForm.cumulative_consumption_times.upperValue;

      if (this.ruleForm.cumulative_consumption_times.enabledState) {
        if (lowerValue == "" || upperValue == "") {
          return callback(new Error("不能未空"));
        }
        if (+lowerValue > +upperValue) {
          return callback(new Error("最小值不能大于最大值"));
        }
      } else {
        if (lowerValue || upperValue) {
          this.ruleForm.cumulative_consumption_times.enabledState = true;
        }
      }

      callback();
    }.bind(this);
    const consumption = function(rule, val, callback) {
      const consumptionValue = this.ruleForm.lately_consumption_time
        .latelyValue;

      const consumptionActivityDate = this.ruleForm.lately_consumption_time
        .activityDate;
      let reg = new RegExp("^[0-9]*$");

      if (this.ruleForm.lately_consumption_time.enabledState) {
        if (this.ruleForm.lately_consumption_time.isSelected == "1") {
          if (consumptionValue == "") {
            return callback(new Error("最后消费时间不能未空"));
          }
        } else if (this.ruleForm.lately_consumption_time.isSelected == "2") {
          if (consumptionActivityDate.length === 0) {
            return callback(new Error("最后消费自定义时间不能未空"));
          }
        }
      }

      if (consumptionValue > 90) {
        return callback(new Error("最后消费时间请填写90天以内"));
      }

      if (!reg.test(consumptionValue)) {
        return callback(new Error("最后消费时间请填写数字"));
      }
      callback();
    }.bind(this);
    const transaction = function(rule, val, callback) {
      const transactionValue = this.ruleForm.transaction_time.latelyValue;
      const transactionActivityDate = this.ruleForm.transaction_time
        .activityDate;

      let reg = new RegExp("^[0-9]*$");
      if (this.ruleForm.transaction_time.isSelected == "1") {
        if (transactionValue == "") {
          return callback(new Error("最近交易时间不能未空"));
        }
      } else {
        if (transactionActivityDate.length === 0) {
          return callback(new Error("最近交易自定义时间不能未空"));
        }
      }

      if (transactionValue > 365) {
        return callback(new Error("最近交易时间请填写365天以内"));
      }

      if (!reg.test(transactionValue)) {
        return callback(new Error("最近交易时间请填写数字"));
      }

      callback();
    }.bind(this);
    const groupIdSelect = function(rule, val, callback) {
      const transactionValue = this.ruleForm.groupIds;
      if (!transactionValue || transactionValue.length < 1) {
        return callback(new Error("请选择标签组!"));
      }
      callback();
    }.bind(this);
    return {
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() > Date.now() + 365 * 8.64e7
          );
        }
      },
      pickerOption: {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() > Date.now() + 90 * 8.64e7
          );
        }
      },
      checkedGoods: [],
      searchCondition: {},
      dialogVisible: false,
      disabled: false,
      isIndeterminate: false,
      transaction: false,
      checkAll: false,
      consumption: false,
      leftRules: [],
      result: [],
      selectedData: [],
      radio: "1",
      rules: {
        labelName: [
          { required: true, message: "请输入标签名称", trigger: "blur" },
          { max: 32, message: "长度在32个字符内", trigger: "blur" }
        ],
        groupId: [
          { required: true, validator:groupIdSelect, trigger: "change" }
        ],
        dataSources: {
          required: true,
          message: "请选择数据来源",
          trigger: "blur"
        },
        labelType: [
          { required: true, message: "请选择标签类型", trigger: "blur" }
        ],
        transaction: [
          { required: true, validator: transaction, trigger: "blur" }
        ],
        consumption: [
          { required: true, validator: consumption, trigger: "blur" }
        ],
        cumulative: [
          { required: true, validator: cumulative, trigger: "blur" }
        ],
        openCardDay: [
          { required: true, validator: transaction, trigger: "blur" }
        ],
        openCardNotConsumed: [
          { required: true, validator: transaction, trigger: "blur" }
        ],
        openCardConsumptionAmount: [
          { required: true, validator: transaction, trigger: "blur" }
        ],
        openCardConsumptionTimes: [
          { required: true, validator: transaction, trigger: "blur" }
        ],
        amount: [
          {
            required: true,
            validator: amount,
            trigger: "blur"
          }
        ],
        unitPrice: [
          {
            required: true,
            validator: unitPrice,
            trigger: "blur"
          }
        ],
        integral: [{ validator: integral, trigger: "blur" }],
        goodsConditionsBo: [{ validator: goodsConditionsBo, trigger: "blur" }]
      },

      checked: false,
      ruleForm: {
        labelName: "",
        groupIds: [],
        dataSources: "",
        labelType: "manual",
        selectConditionType: "anyone",
        transaction_time: {
          activityDate: [],
          key: "transaction_time",
          latelyValue: "",
          isSelected: "",
          startValue: "",
          endValue: "",
          enabledState: true
        },
        lately_consumption_time: {
          activityDate: [],
          key: "lately_consumption_time",
          latelyValue: "",
          startValue: "",
          isSelected: "",
          endValue: "",
          enabledState: false
        },
        cumulative_consumption_times: {
          key: "cumulative_consumption_times",
          lowerValue: "",
          upperValue: "",
          enabledState: false
        },
        cumulative_consumption_amount: {
          key: "cumulative_consumption_amount",
          lowerValue: "",
          upperValue: "",
          enabledState: false
        },
        customer_unit_price: {
          key: "customer_unit_price",
          lowerValue: "",
          upperValue: "",
          enabledState: false
        },
        cumulative_total_integral: {
          key: "cumulative_total_integral",
          lowerValue: "",
          upperValue: "",
          enabledState: false
        },
        goodsConditionsBo: {
          key: "goods_whitelist",
          enabledState: false,
          goodsWhitelistBo: [
            { attrId: "", attrType: "", attrValue: "", whitelistState: "" }
          ]
        },
        openCardDayChecked: false,
        openCard_day: {
          key: "openCard_day",
          openCardDay: "",
          enabledState: false
        },
        openCard_not_consumed: {
          key: "openCard_not_consumed",
          openCardDay: "",
          enabledState: false
        },
        openCard_consumption_amount: {
          key: "openCard_consumption_amount",
          lowerValue: "",
          upperValue: "",
          openCardDay: "",
          enabledState: false
        },
        openCard_consumption_times: {
          key: "openCard_consumption_times",
          lowerValue: "",
          upperValue: "",
          openCardDay: "",
          enabledState: false
        },
      },
      labelGroupList: []
    };
  },
  computed: {},
  watch: {
    result(val) {
      if (!val.length) {
        this.checkAll = false;
      } else {
        this.ruleForm.goodsConditionsBo.enabledState = true;
      }
    },
    "ruleForm.transaction_time.isSelected": {
      handler(val) {
        if (val == "1") {
          this.ruleForm.transaction_time.activityDate = [];
          this.transaction = false;
        } else {
          this.ruleForm.transaction_time.latelyValue = "";
          this.transaction = true;
        }
      },
      deep: true
    },

    "ruleForm.lately_consumption_time.isSelected": {
      handler(val) {
        // if (val) {
        //   this.ruleForm.lately_consumption_time.enabledState = true;
        // }
        if (val == "1") {
          this.ruleForm.lately_consumption_time.activityDate = [];
          this.consumption = false;
        } else if (val == "2") {
          this.ruleForm.lately_consumption_time.latelyValue = "";
          this.consumption = true;
        }
      },
      deep: true,
    }
  },
  created() {},
  mounted() {
    this.queryLabelGroupList();
    this.labelDetail().then(res => {
      const result = res.result;
      // if( result.paramOne[0].transaction_time.isSelected)
      // result.transaction_time.activityDate
      if (result.paramTwo) {
        result.paramTwo.forEach(v => {
          if (v.enabledState == "true") {
            v.enabledState = true;
          } else {
            v.enabledState = false;
          }
          this.ruleForm[v.key] = v;
        });
      }

      if (result.paramOne) {
        result.paramOne.map(v => {
          if (v.key === "transaction_time") {
            this.ruleForm.transaction_time.enabledState = v.enabledState;
            this.ruleForm.transaction_time.isSelected = v.isSelected;
            if (v.isSelected === "1") {
              this.ruleForm.transaction_time.latelyValue = v.latelyValue;
            } else if (v.isSelected === "2") {
              this.ruleForm.transaction_time.activityDate = [
                v.startValue,
                v.endValue
              ];
            }
          } else if (v.key === "lately_consumption_time") {
            this.ruleForm.lately_consumption_time.enabledState = v.enabledState;
            this.ruleForm.lately_consumption_time.isSelected = v.isSelected;
            if (v.isSelected === "1") {
              this.ruleForm.lately_consumption_time.latelyValue = v.latelyValue;
            } else if (v.isSelected === "2") {
              this.ruleForm.lately_consumption_time.activityDate = [
                v.startValue,
                v.endValue
              ];
            }
          }
        });
      }

      if (result.goodsConditionsBo) {
        this.selectedData = result.goodsConditionsBo.goodsWhitelistBo;
        this.result = result.goodsConditionsBo.goodsWhitelistBo;
      }

      if (result.openCardRuleModels) {
        result.openCardRuleModels.map(v => {
          if (v.key === "openCard_not_consumed") {
            this.ruleForm.openCard_not_consumed.enabledState = v.enabledState === 'true' ? true : false;
            this.ruleForm.openCard_not_consumed.openCardDay = v.openCardDay;
          }
          if (v.key === "openCard_day") {
            this.ruleForm.openCard_day.enabledState = v.enabledState === 'true' ? true : false;
            this.ruleForm.openCard_day.openCardDay = v.openCardDay;
          }
          if (v.key === "openCard_consumption_times") {
            this.ruleForm.openCard_consumption_times.enabledState = v.enabledState === 'true' ? true : false;
            this.ruleForm.openCard_consumption_times.openCardDay = v.openCardDay;
            this.ruleForm.openCard_consumption_times.lowerValue = v.lowerValue;
            this.ruleForm.openCard_consumption_times.upperValue = v.upperValue;
          }
          if (v.key === "openCard_consumption_amount") {
            this.ruleForm.openCard_consumption_amount.enabledState = v.enabledState === 'true' ? true : false;
            this.ruleForm.openCard_consumption_amount.openCardDay = v.openCardDay;
            this.ruleForm.openCard_consumption_amount.lowerValue = v.lowerValue;
            this.ruleForm.openCard_consumption_amount.upperValue = v.upperValue;
          }
        });
      }
      for (let key in result) {
        this.ruleForm[key] = result[key];
      }
    });
  },
  methods: {
    async queryLabelGroupList() {
      const params = {
        pageSize: 9999,
        pageNo: 1,
      };
      const { code, result } = await this.$store.dispatch("queryLabelGroupList", params);
      if (code === "0") {
        const { records } = result;
        this.labelGroupList = records;
      }
    },
    filterGt0OrFixed0(cumulative, prop) {
      this.ruleForm[cumulative][prop] = this.ruleForm[cumulative][prop].replace(
        /^(0+)/,
        ""
      ); //过滤0开头
      this.ruleForm[cumulative][prop] = this.ruleForm[cumulative][prop].replace(
        /[^\d]/g,
        ""
      );
      this.ruleForm[cumulative][prop] = this.ruleForm[cumulative][prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    filterGt0OrFixed2(cumulative, prop) {
      // this.ruleForm[cumulative][prop] = this.ruleForm[cumulative][prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[cumulative][prop] = this.ruleForm[cumulative][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.ruleForm[cumulative][prop] = this.ruleForm[cumulative][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.ruleForm[cumulative][prop] = this.ruleForm[cumulative][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[cumulative][prop] = this.ruleForm[cumulative][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.ruleForm[cumulative][prop].indexOf(".") < 0 &&
        this.ruleForm[cumulative][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm[cumulative][prop] = parseFloat(
          this.ruleForm[cumulative][prop]
        );
      }
    },
    labelDetail() {
      const { labelId } = this.$route.query;
      const params = {
        labelId
      };
      return this.$store.dispatch("queryLabelDetail", params);
    },
    handleCheckAllChange(val) {
      this.checkedGoods = val ? this.result : [];
      this.isIndeterminate = false;
    },
    deleteSelected() {
      if (this.checkedGoods.length) {
        this.$confirm("删除所有选中的结果？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.selectedData = this.selectedData.filter(
            v =>
              !this.checkedGoods.some(
                item => String(v.attrId) === String(item.attrId)
              )
          );
          this.result = this.selectedData;
          this.checkedGoods = [];
        });
      } else {
        this.$message({
          type: "error",
          message: "请先选择商品"
        });
      }
    },
    deleteCurrentGoods(v, i) {
      this.selectedData.splice(i, 1);
      this.result = this.selectedData;
    },
    handleCheckedGoodsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.result.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.result.length;
    },
    saveSelected() {
      let rightChecked = this.$refs.ruleTransfer.rightChecked;

      if (
        (rightChecked.find(o => o.attrType === "attribute") &&
          rightChecked.find(o => o.attrType !== "attribute")) ||
        (rightChecked.find(o => o.attrType === "attribute") &&
          this.selectedData.find(o => o.attrType !== "attribute")) ||
        (rightChecked.find(o => o.attrType !== "attribute") &&
          this.selectedData.find(o => o.attrType === "attribute"))
      ) {
        this.$message({
          type: "error",
          message: "标签不能与品牌、品类、商品共存！"
        });
      } else {
        rightChecked.forEach((v, i) => {
          this.selectedData.forEach(j => {
            if (v.attrId === j.attrId) {
              rightChecked.splice(i, 1);
            }
          });
        });

        // const data = this.selectedData.concat(rightChecked);
        this.selectedData.push(...rightChecked);

        this.result.push(...rightChecked);

        this.dialogVisible = false;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ruleForm.labelType !== "manual") {
            this.ruleForm.goodsConditionsBo.goodsWhitelistBo = this.result;

            this.ruleForm.transaction_time.startValue =
              this.ruleForm.transaction_time.activityDate &&
              this.ruleForm.transaction_time.activityDate.length > 0
                ? this.ruleForm.transaction_time.activityDate[0]
                : "";
            this.ruleForm.transaction_time.endValue =
              this.ruleForm.transaction_time.activityDate &&
              this.ruleForm.transaction_time.activityDate.length > 0
                ? this.ruleForm.transaction_time.activityDate[1]
                : "";

            this.ruleForm.lately_consumption_time.startValue =
              this.ruleForm.lately_consumption_time.activityDate &&
              this.ruleForm.lately_consumption_time.activityDate.length > 0
                ? this.ruleForm.lately_consumption_time.activityDate[0]
                : "";
            this.ruleForm.lately_consumption_time.endValue =
              this.ruleForm.lately_consumption_time.activityDate &&
              this.ruleForm.lately_consumption_time.activityDate.length > 0
                ? this.ruleForm.lately_consumption_time.activityDate[1]
                : "";

            this.ruleForm.paramOne = [];
            this.ruleForm.paramOne.push(this.ruleForm.transaction_time);
            this.ruleForm.paramOne.push(this.ruleForm.lately_consumption_time);
            this.ruleForm.paramTwo = [];
            this.ruleForm.paramTwo.push(
              this.ruleForm.cumulative_consumption_times
            );
            this.ruleForm.paramTwo.push(
              this.ruleForm.cumulative_consumption_amount
            );
            this.ruleForm.paramTwo.push(this.ruleForm.customer_unit_price);
            this.ruleForm.paramTwo.push(
              this.ruleForm.cumulative_total_integral
            );
          }
          this.ruleForm.openCardRuleModels = [];
          this.ruleForm.openCardRuleModels.push(this.ruleForm.openCard_day);
          this.ruleForm.openCardRuleModels.push(this.ruleForm.openCard_not_consumed);
          this.ruleForm.openCardRuleModels.push(this.ruleForm.openCard_consumption_amount);
          this.ruleForm.openCardRuleModels.push(this.ruleForm.openCard_consumption_times);

          let params = this.ruleForm;
          this.$store.dispatch("editLabel", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.tabless {
  margin: 20px 0;
  border: 1px solid #eaeaea;
  .delete {
    cursor: pointer;
    user-select: none;
  }
  .table-out-header,
  .no-message {
    padding: 12px;
  }
  .table-header {
    padding: 12px;
    background: #f7f7f7;
    font-size: 12px;
    .num {
      padding-left: 26px;
    }
  }
  .table-body {
    font-size: 12px;
    .row {
      padding: 12px;
      font-size: 12px;
    }
    .list-item:nth-child(even) {
      background: #f7f7f7;
    }
    .delete-icon {
      cursor: pointer;
      font-size: 12px;
    }
  }
}
.attrid {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 274px;
}
</style>
